<template>
  <div class="common-horizontal-bar">
    <div :id="barIdName" :style="{width: width, height: height}"></div>
  </div>
</template>

<script>
  import {debounce} from '../../utils/util'
  export default {
    name: 'upper-horizontal-bar',
    props: {
      barIdName: {
        type: String,
        default () {
          return 'commonHorizontalBar'
        }
      },
      width: {
        type: String,
        default () {
          return '100%'
        }
      },
      height: {
        type: String,
        default () {
          return '220px'
        }
      },
      titleShow: {
        type: Boolean,
        default () {
          return true
        }
      },
      barTitle: {
        type: String,
        default () {
          return ''
        }
      },
      colorList: {
        type: Array,
        default () {
          return ['#5B9BD5', '#ED7D31', '#FFC000', '#A5A5A5']
        }
      },
      yAxis: {
        type: Array,
        default () {
          return []
        }
      },
      series: {
        type: Array,
        default () {
          return []
        }
      }
    },
    data () {
      return {
        commonHorizontalBarId: null
      }
    },
    mounted () {
      this.drawCommonHorizontalBar()
      window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.resizeChart)
    },
    methods: {
      drawCommonHorizontalBar() {
        this.commonHorizontalBarId = this.$echarts.init(document.getElementById(this.barIdName))
        this.commonHorizontalBarId.setOption({
          title: {
            show: this.titleShow,
            text: this.barTitle,
            titleStyle: {
              color: '#333333'
            }
          },
          tooltip : {
            trigger: 'axis',
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {},
          grid: {
            left: '30px',
            right: '50px',
            bottom: '0px',
            containLabel: true
          },
          color: this.colorList,
          xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            splitLine: {
              show: false
            },
          },
          yAxis: {
            type: 'category',
            data: this.yAxis
          },
          series: this.series
        })
      },
      resizeChart: debounce(function () {
        this.commonHorizontalBarId.resize()
      }, 100)
    },
    watch: {
      series () {
        this.drawCommonHorizontalBar()
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/UpperEcharts/upperHorizontalBar.vue